var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkill21(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.318 32.318",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2,31.1c-8.3,0-15-6.7-15-15s6.7-15,15-15c8.3,0,15,6.7,15,15l0,0C31.1,24.4,24.4,31.1,16.2,31.1 M16.2,0 C7.2,0,0,7.2,0,16.2s7.2,16.2,16.2,16.2s16.2-7.2,16.2-16.2l0,0l0,0C32.3,7.2,25.1,0,16.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8,17.2c0,0.4,0.1,0.7,0.1,1.1l1.2-0.4L2.8,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2,15.1l-2.7-3.3c-0.3,0.9-0.5,1.9-0.7,2.8L6.2,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6,11.4l5.6,0.2L9.4,10L6.3,7.2c-0.9,1-1.7,2.2-2.3,3.5L4.6,11.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.2,12.6 12,12.6 14.4,16.1 16.4,16.4 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.6,12.5 5.2,12.1 8.1,15.3 12.4,15.9 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1,14.3l0-3.3l-3.5-8.1c-0.1,0-0.2,0-0.3,0l-0.3,5.9L19.1,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,15.8l-3.9-6.2L7.6,6C7.3,6.2,7,6.5,6.7,6.7L18,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2,7.6L14.6,3c-1.1,0.1-2.2,0.4-3.3,0.8L14.2,7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2,8.1l-2.5-4C9.8,4.5,8.9,4.9,8.2,5.5L13.2,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8,15.6c0,0.2,0,0.4,0,0.7c0,0,0,0.1,0,0.1L5,17.5l2.7-1L2.8,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3,14.3l1.7-4l-0.7-6.4c-0.3-0.1-0.5-0.2-0.8-0.3c0,0,0,0-0.1,0c-0.1,0-0.2-0.1-0.3-0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0 L20.3,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6,8.6L24,5.4c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0c-0.1-0.1-0.2-0.1-0.3-0.2c0,0,0,0,0,0C23.4,5,23.4,5,23.3,4.9 c0,0,0,0,0,0c-0.1,0-0.2-0.1-0.2-0.1c0,0,0,0-0.1,0c-0.1,0-0.2-0.1-0.2-0.1c0,0,0,0-0.1,0c-0.1,0-0.2-0.1-0.2-0.1c0,0,0,0-0.1,0 c-0.1,0-0.2-0.1-0.3-0.1c0,0,0,0-0.1,0c-0.1,0-0.1,0-0.2-0.1L22.6,8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2,8.4l0.1-5.2c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0 c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0 c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0L19.2,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9,28.5c1.7-1.3,3.8-3.3,5.6-5.5c0.6-0.2,1.4-0.7,2.4-1.7C26.4,24.8,23.5,27.4,19.9,28.5 M16.2,29.1 c-1.7,0-3.4-0.3-4.9-1c0.2,0,0.4-0.1,0.5-0.1c1.4-0.3,2.6-0.6,3.5-1c2.7-1.5,7.2-3.3,9.5-3.8C23,25,20.4,27.5,17.6,29 C17.1,29,16.6,29.1,16.2,29.1 M24.7,16l-3.8,2.3l0.7,5.2c-1.1,0.4-2.2,0.8-3.3,1.3l0.3-6.3l-9.3-1.7L3,18.8 C4.2,25,9.6,29.7,16.2,29.7c7.4,0,13.4-6,13.4-13.4c0-0.2,0-0.4,0-0.5L24.7,16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2,13.3l-3,1.8l3.3,0.1C29.5,14.5,29.4,13.9,29.2,13.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9,9.8l-0.3,3.5l1.5-0.6C28.8,11.6,28.4,10.7,27.9,9.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5,13.7L27.4,9c-0.2-0.2-0.3-0.5-0.5-0.7l-4.1,3.4l-1.4,4.2L26.5,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5,9.5l3-1.8c-0.5-0.6-1.1-1.2-1.8-1.8L23.5,9.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill21);
export default __webpack_public_path__ + "static/media/skill21.5ae03800.svg";
export { ForwardRef as ReactComponent };